<template>
    <div class="flex items-center gap-2">
        <DsIcon
            icon="fa-regular fa-file-lines"
            size="md"
        />
        <div>
            <p class="text-content-md text-content-primary">
                {{ documentTitle }}
            </p>
            <p
                v-if="signersCount"
                class="text-content-sm text-content-secondary"
            >
                {{ signersCount }} signer(s)
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import type { DocumentTemplateOption } from '@/components/Views/Company/File/Documents/document-upload-utils';
import type { DocumentUploadConfig } from '@/components/Views/Company/File/file.types';

defineProps<{
    documentTitle: DocumentUploadConfig['title'];
    signersCount: DocumentTemplateOption['signersCount'];
}>();
</script>
